import { render, staticRenderFns } from "./SchoolApplicationListItem.vue?vue&type=template&id=83efd932&scoped=true&lang=pug&"
import script from "./SchoolApplicationListItem.vue?vue&type=script&lang=js&"
export * from "./SchoolApplicationListItem.vue?vue&type=script&lang=js&"
import style0 from "./SchoolApplicationListItem.vue?vue&type=style&index=0&id=83efd932&lang=scss&scoped=true&"
import style1 from "./SchoolApplicationListItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83efd932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
